module.exports = __webpack_public_path__ + "51abdbcd0e90b38a084a94af97d00a65.wasm";